// Suivi de conversions centralisé — Google Ads + Google Analytics (GA4)
// Le tag de base (gtag.js) est chargé dans public/index.html :
//   - GA4     : G-9X6R47K2KW
//   - Ads     : AW-18346007153

const GOOGLE_ADS_ID = "AW-18346007153";

// ⚠️ LIBELLÉS DE CONVERSION GOOGLE ADS
// Dans Google Ads : Outils → Mesure → Conversions → (créer une action) → « Utiliser Google Tag ».
// Copiez l'« Étiquette de conversion » de chaque action ci-dessous (juste la partie après le "/").
// Exemple : si Google Ads affiche  send_to: 'AW-18346007153/AbC-dEfGhIj'  → mettez "AbC-dEfGhIj".
// Tant qu'un libellé est vide, seul l'événement GA4 est envoyé (Google Ads sera activé dès l'ajout).
export const ADS_LABELS = {
  appointment: "",     // Prise de rendez-vous confirmée
  contact: "",         // Envoi du formulaire de contact
  signup: "",          // Inscription d'un nouveau client
  begin_checkout: "",  // Achat d'un pack (démarrage du paiement)
  purchase: "",        // Paiement réussi via Stripe
};

const gtag = (...args) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
};

// Envoie un événement GA4 + (si le libellé est configuré) une conversion Google Ads.
export function trackConversion(key, { ga4Event, params = {}, adsParams = {} } = {}) {
  if (ga4Event) gtag("event", ga4Event, params);
  const label = ADS_LABELS[key];
  if (label) {
    gtag("event", "conversion", { send_to: `${GOOGLE_ADS_ID}/${label}`, ...adsParams });
  }
}

// ————— Wrappers pratiques (une fonction par conversion clé) —————

export const trackAppointment = (destination) =>
  trackConversion("appointment", {
    ga4Event: "book_appointment",
    params: { event_category: "engagement", destination: destination || "n/a" },
  });

export const trackContact = () =>
  trackConversion("contact", {
    ga4Event: "contact_form",
    params: { event_category: "engagement" },
  });

export const trackSignup = (method = "email") =>
  trackConversion("signup", {
    ga4Event: "sign_up",
    params: { method },
  });

export const trackBeginCheckout = (pack) =>
  trackConversion("begin_checkout", {
    ga4Event: "begin_checkout",
    params: {
      currency: (pack?.currency || "EUR").toUpperCase(),
      value: pack?.price || 0,
      items: [{ item_id: pack?.id, item_name: pack?.name || pack?.title, price: pack?.price }],
    },
  });

export const trackPurchase = ({ transaction_id, value = 0, currency = "EUR" }) => {
  // Garde anti-doublon: 1 seule conversion par session Stripe (StrictMode, refresh, re-visite)
  if (transaction_id && typeof window !== "undefined") {
    const key = `wte_purchase_${transaction_id}`;
    try {
      if (window.sessionStorage.getItem(key)) return;
      window.sessionStorage.setItem(key, "1");
    } catch (_) { /* sessionStorage indisponible: on continue */ }
  }
  const cur = (currency || "EUR").toUpperCase();
  trackConversion("purchase", {
    ga4Event: "purchase",
    params: { transaction_id, value, currency: cur },
    adsParams: { transaction_id, value, currency: cur },
  });
};
